export const GET_SERVICES_STOPLIST_STARTED = 'GET_SERVICES_STOPLIST_STARTED'
export const GET_SERVICES_STOPLIST_ERROR = 'GET_SERVICES_STOPLIST_ERROR'
export const GET_SERVICES_STOPLIST_SUCCESS = 'GET_SERVICES_STOPLIST_SUCCESS'
